module.exports = __webpack_public_path__ + "img/logo.e4ce4878.png";